import React from 'react';
import { useIntl } from 'react-intl';
// Models
import {
  trigger, slaveFromTrigger, triggerCanHaveEquipement, installationName,
} from 'models/device';
import { isMotherboard } from 'models/deviceSlave';
// Custom
import { deviceDataShape, scenarioTriggerDataShape } from 'constants/PropTypesShapes';
import { joinNonEmpty } from 'utils/Tools';
import withDeviceData from 'appAssets/hocs/WithDeviceData';
import TriggerItem from 'installations/assets/configuration/TriggerItem';

const AntipassbackScenarioTriggerItem = ({ deviceData, scenarioTrigger }) => {
  const intl = useIntl();
  if (deviceData) {
    // Get trigger object
    const triggerObj = trigger(scenarioTrigger.trigger_id, deviceData);
    // Get slave from trigger
    const deviceSlave = slaveFromTrigger(triggerObj.id, deviceData);
    // If the trigger can have equipments, display slave name
    const deviceName = installationName(deviceData);
    const deviceLabel = !triggerCanHaveEquipement(triggerObj)
      ? deviceName
      : joinNonEmpty([deviceName, intl.formatMessage({ id: 'title.deviceSlave' }, { isMotherboard: isMotherboard(deviceSlave), desc: deviceSlave.name })], ' - ');

    return (
      <TriggerItem
        deviceLabel={deviceLabel}
        trigger={triggerObj}
        idTrigger={scenarioTrigger.trigger_id}
      />
    );
  }
  return null;
};

AntipassbackScenarioTriggerItem.propTypes = {
  deviceData: deviceDataShape,
  scenarioTrigger: scenarioTriggerDataShape.isRequired,
};

AntipassbackScenarioTriggerItem.defaultProps = {
  deviceData: null,
};

module.exports = withDeviceData('scenarioTrigger.device_id')(AntipassbackScenarioTriggerItem);



// WEBPACK FOOTER //
// ./routes/app/routes/installations/assets/antipassbacks/AntipassbackScenarioTriggerItem.js